import Swiper from 'swiper'
import 'swiper/swiper-bundle.min.css'

export class KvAnimation {
  constructor() {
    // 配列をシャッフルする関数
    function shuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[array[i], array[j]] = [array[j], array[i]]
      }
      return array
    }

    const zeroPadding = (i) => String(i).padStart(2, '0')

    document.addEventListener('DOMContentLoaded', () => {
      const breakPoint = 768
      let currentIndex = 0
      let time = 200
      let slideLength = 2
      if (!document.querySelector('.js-kv')) return
      const timer = () => {
        let current = zeroPadding(currentIndex + 1)
        const items = document.querySelectorAll('.js-kv_slide_item')
        items.forEach((item, i) => {
          const itemSlides = item.querySelectorAll('.js-slide_inner')
          const target = item.querySelector(`.js-slide_inner.-s${current}`)
          itemSlides.forEach((elm) => {
            const itemHuman = elm.querySelector('.js-human')
            const targetHuman = target.querySelector('.js-human')
            setTimeout(() => {
              elm.classList.remove('is-act')
              elm.classList.add('is-hide')
              itemHuman.classList.remove('is-act')
              itemHuman.classList.add('is-hide')
              target.classList.remove('is-hide')
              target.classList.add('is-act')
              targetHuman.classList.remove('is-hide')
              targetHuman.classList.add('is-act')
            }, time * i)
          })
        })
        time = 200 // time初期化
        currentIndex++ // スライドの枚数に達するまで増やす
        if (currentIndex === slideLength) {
          // スライドの枚数に達したら初期化
          currentIndex = 0
        }
      }

      const opening = () => {
        const options = {
          itemDelay: 300,
          copyDelay: 100,
        }
        const kv = document.querySelector('.js-kv')
        if (!kv) return
        const copies = Array.from(document.querySelectorAll('.js-copy_text'))
        const items = Array.from(document.querySelectorAll('.js-kv_slide_item'))
        const copy = document.querySelector('.js-kv_copy_sub')
        const line = document.querySelector('.js-kv_line')
        const shuffledItems = shuffle(items)
        const shuffledCopies = shuffle(copies)

        shuffledItems.forEach((elm, index) => {
          const human = elm.querySelector('.js-human')
          if (window.innerWidth <= breakPoint) {
            elm.classList.add('is-show')
            setTimeout(() => {
              human.classList.add('is-act')
            }, 1000)
          } else {
            setTimeout(() => {
              elm.classList.add('is-show')
              setTimeout(() => {
                human.classList.add('is-act')
              }, 1000)
            }, options.itemDelay * index)
          }
        })
        setTimeout(() => {
          kv.classList.add('is-show')
        }, 1000)
        setTimeout(() => {
          shuffledCopies.forEach((elm, index) => {
            setTimeout(() => {
              elm.classList.add('is-show')
            }, options.copyDelay * index)
          })
        }, 1800)
        setTimeout(() => {
          copy.classList.add('is-show')
          line.classList.add('is-show')
          timer()
        }, 3000)
      }

      const swiperSlide = () => {
        const swiperOptions = {
          loop: true,
          spaceBetween: 10,
          slidesPerView: 1.4,
          centeredSlides: true,
          effect: 'coverflow',
        }
        let swiper
        if (window.innerWidth <= breakPoint) {
          swiper = new Swiper('.js-index_kv_slider', swiperOptions)
        } else {
          swiper = undefined
        }
        window.addEventListener(
          'resize',
          () => {
            if (window.innerWidth <= breakPoint) {
              if (swiper) return
              swiper = new Swiper('.js-index_kv_slider', swiperOptions)
            } else {
              if (!swiper) return
              swiper.destroy()
              swiper = undefined
            }
          },
          false
        )
      }
      // 初回用の関数を実行
      opening()
      // スマホは3秒 PCは5秒ごとにtimer関数を実行
      setInterval(timer, window.innerWidth <= breakPoint ? 3000 : 5000)
      // スマホ時はswiperを実行
      swiperSlide()
    })
  }
}
